import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  Box,
  CircularProgress,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { useTheme } from '@mui/material/styles'
import {
  fetchConversationThread,
  setSelectedConversationId,
  setSelectedUserId,
} from 'src/redux/chatbotConversations'
import { formatDate } from './helpers'

const UserConversationList = () => {
  const theme = useTheme()
  const dispatch = useDispatch()
  const { userConversations, userConversationsLoading, selectedUserId, selectedConversationId, users } =
    useSelector(state => state.chatbotConversations)

  const selectedUser = users.find(user => user.userId === selectedUserId)

  const handleBack = () => {
    dispatch(setSelectedUserId(null))
  }

  const handleConversationClick = conversationId => {
    dispatch(setSelectedConversationId(conversationId))
    dispatch(fetchConversationThread(conversationId))
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box
        sx={{
          p: 2,
          borderBottom: `1px solid ${theme.palette.grey[200]}`,
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          flexShrink: 0,
        }}
      >
        <IconButton size='small' onClick={handleBack}>
          <ArrowBackIcon fontSize='small' />
        </IconButton>
        <Typography variant='subtitle2' noWrap>
          {selectedUser?.userEmail ?? 'User conversations'}
        </Typography>
      </Box>

      {userConversationsLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
          <CircularProgress size={32} />
        </Box>
      ) : (
        <Box sx={{ flex: 1, overflowY: 'auto' }}>
          <List disablePadding>
            {userConversations.map(conversation => (
              <ListItemButton
                key={conversation.conversationId}
                selected={conversation.conversationId === selectedConversationId}
                onClick={() => handleConversationClick(conversation.conversationId)}
                divider
              >
                <ListItemText
                  primary={conversation.firstMessagePreview ?? 'Conversation'}
                  secondary={
                    <Typography component='span' variant='caption' color='textSecondary'>
                      {conversation.requestCount} requests &middot;{' '}
                      {formatDate(conversation.firstRequestAt)} -{' '}
                      {formatDate(conversation.lastRequestAt)}
                    </Typography>
                  }
                  primaryTypographyProps={{
                    variant: 'body2',
                    sx: {
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                    },
                  }}
                />
              </ListItemButton>
            ))}
            {userConversations.length === 0 && (
              <Box sx={{ p: 3, textAlign: 'center' }}>
                <Typography variant='body2' color='textSecondary'>
                  No conversations found
                </Typography>
              </Box>
            )}
          </List>
        </Box>
      )}
    </Box>
  )
}

export default UserConversationList
